module.exports = __webpack_public_path__ + "static/img/content5.f453910.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/content5.png
// module id = yGp2
// module chunks = 1 3